import {useState, Outlet, Navigate } from 'react-router-dom'


const ProtectdFilmRoute = () => {

   let filmRight =   sessionStorage.getItem('filmRight')
   
    return filmRight === 'true'  ? <Outlet /> : <Navigate to='/'/>
}

export default ProtectdFilmRoute